'use strict';

function KYCQuestions() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_AccountController, _AnalyticsData];
  this._blackbox = '';
  this._submittedAnswers = null;
  this._submitButton = null;
  this._onSubmitAnswersCallback = null;
  this._onReceiveQuestionsCallback = null;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();

    mogo.registry.mogoUI.repo.Portal.branchSetIdentity();

    // Skip to Next Step or bounce back
    if (this.hasPassedKYC() || !this.hasAllProfileInfo() || !this.hasProvidedConsent()) {
      this.routeToNextStep();
      return;
    }

    if (!this.presenter.hasAction('account.create_kyc_questions')) {
      // old system still used if user comes back to this page,
      // has not passed KYC,
      // but needs routed to edge case page, eg province declined.
      var _oldValidator = this._validatePageRequest(); // reroutes if needed
      console.warn('KYCQuestions: user missing create_kyc_questions action.');
      return;
    }

    // start KYC Questions process:
    this._checkForBlackbox(0);
    this._submitButton = $('.btn', this.node);
    this.analytics.pushEvent('virtual-page-view');
    var _window = window,
        analytics = _window.analytics;


    analytics.track('Flow Started', {
      flow_id: 'kyc',
      product_id: 'mogo',
      screen_name: 'onboarding kyc questions'
    });
  };

  this._checkForBlackbox = function (i) {
    if (i === 50) {
      this.analytics.pushEvent('fraud-status', {
        VerificationStatus: ['script-error']
      });
      return this._requestQuestions(); // after 5 seconds, send empty blackbox
    }
    if (io_bb_received) {
      var io = ioGetBlackbox();
      this._blackbox = io.blackbox;
      return this._requestQuestions();
    }
    var node = this;
    setTimeout(function () {
      i++;
      node._checkForBlackbox(i);
    }, 100);
  };

  this._requestQuestions = function () {
    this._onReceiveQuestionsCallback = this.presenter.addCallbackToAction('account.create_kyc_questions', $.proxy(this._onReceiveQuestions, this));
    this.questionsRequest = this.presenter.performAction('account.create_kyc_questions', {
      device_print: this._blackbox
    });
  };

  this._onReceiveQuestions = function (data, response) {
    if (data.errors) {
      // See GA Action "KYC Error Response"
      this.analytics.forcePushEvent('generic-api-response-error', {
        event: ['KYCPartnerResponseError'],
        Code: [data.errors[0].code],
        Key: [data.errors[0].key],
        Msg: [data.errors[0].msg],
        Property: [data.errors[0].property]
      });
    }

    // Equifax Timeout (devOps has flipped switch to disable the kyc feature)
    if (response === 503 && data.errors[0].key === 'retry') {
      if (window.location.pathname !== this.paths.signup.kyc_partner_down) {
        // set kyc_decision to kyc_partner_down status. KYCPartnerDown will use the property as an reference
        // as an guard from hitting the end point twice.
        this.presenter.models.account.setModelProperty('kyc_decision', 'kyc_partner_down');
      }

      // go to partner down URL when Equifax timesout
      this.history.goToUrl(this.paths.signup.kyc_partner_down);
    } else if (response === 500 && data.errors[0].key === 'equifax_remote_service_error') {
      this.handleDeclinedState(data, response);
    } else if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage({
        action: 'account.create_kyc_questions',
        data: { device_print: this._blackbox }
      }, { productLabel: 'MogoMember' });
    } else if (response === 200) {
      if (data.kyc_decision === 'declined' || data.kyc_decision === 'permanently_failed' || data.kyc_decision === 'profile_not_found') {
        this.analytics.pushEvent('account-status', {
          AccountStatus: [data.kyc_decision]
        });
        this.handleDeclinedState(data, response);
      } else {
        // console.log(data.kyc_questions); // these always come back diff
        this.presenter.models.account.updateModel(data, $.proxy(this._prepareQuestions, this));
        this._submitButton.show();
        this.analytics.pushEvent('fraud-status', {
          VerificationStatus: [this.presenter.models.account.fraud_decision]
        });

        // Loader
        $('form .progress-spinner').hide();
      }
    } else {
      this.handleDeclinedState(data, response);
    }
  };

  this._onSubmitAnswers = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      // Timeout
      this.invokeConnectionIssuePage({ action: 'account.kyc_answers', data: this._submittedAnswers }, { productLabel: 'MogoMember' });
    } else if (response === 200) {
      if (data.kyc_decision === 'declined') {
        // Declined on First Attempt
        this.history.goToUrl(this.paths.signup.declined.kyc_first_attempt);
      } else if (data.kyc_decision === 'permanently_failed') {
        // Declined on Last Attempt
        this.history.goToUrl(this.paths.signup.declined.kyc_last_attempt);
      } else {
        // Success Case
        this._submitAnswersSuccess(data);
      }
    } else {
      this._setButtonLoadState(false);

      switch (data.errors[0].key) {
        case 'member_service_kyc_questions_expired':
          if (this.presenter.models.account.kyc_attempts === 0) {
            // Questions Expired on First Attempt
            this.history.goToUrl(this.paths.signup.declined.kyc_first_attempt);
          } else {
            // Questions Expired on Last Attempt
            this.history.goToUrl(this.paths.signup.declined.kyc_last_attempt);
          }
          break;
        case 'member_kyc_max_attempts':
          this.history.goToUrl(this.paths.signup.declined.kyc_last_attempt);
          break;
        case 'member_service_kyc_already_approved':
          this._submitAnswersSuccess(data);
          break;
        default:
          // Unexpected Case
          $('#Notification').mogo().get();

          try {
            FS.event('Mogo App Debug', {
              name: 'Unexpected kyc response'
            });
          } catch (e) {}
      }
    }
  };

  this._submitAnswersSuccess = function (data) {
    // Segment Analytics
    var _window2 = window,
        analytics = _window2.analytics;


    analytics.track('Flow Completed', {
      flow_id: 'kyc',
      product_id: 'mogo',
      screen_name: 'onboarding kyc questions'
    });

    this.analytics.pushEvent('account-status', {
      AccountStatus: ['customer-passed-kyc']
    });

    // Take user to credit check
    this.presenter.models.account.updateModel(data, this.routeToNextStep.bind(this));
  };

  this._prepareQuestions = function () {
    var kyc_questions = $.parseJSON(this.presenter.models.account.kyc_questions);
    var container = $('#questions-form .questions');
    var validationObj = {};

    $.each(kyc_questions, function (index, question) {
      var row = $("<div class='row'></div>");
      var column = $('<div class="large-12 columns"></div>').append($('<h4></h4>', { text: question.text }));
      var booleanGroup = $('<div></div>', {
        id: 'question_' + question.id,
        'data-mogo-ui': 'BooleanGroup',
        'data-mogo-ui-error': 'Please select an answer'
      });

      $.each(question.choices, function (i, answer) {
        $('<input />', {
          'data-mogo-ui': 'Radio',
          type: 'radio',
          id: 'answer_' + question.id + '_' + i,
          name: 'question_' + question.id,
          placeholder: answer[1],
          value: 'answer_' + answer[0]
        }).appendTo(booleanGroup);
      });

      booleanGroup.appendTo(column);
      $('<hr/>').appendTo(column);
      column.appendTo(row);
      row.appendTo(container);

      // Validation details
      var _Validator = Validator,
          Assert = _Validator.Assert;

      validationObj['question_' + question.id] = {
        assertion: [new Assert().NotNull()]
      };
    });

    container.mogo().parse();

    $('form#questions-form').mogo().create('Validation', {
      validationObj: validationObj,
      callback: $.proxy(this._onValidate, this)
    });
  };

  this._onValidate = function (result) {
    if (result) {
      this._setButtonLoadState(true);
      var data = $('form', this.node).serializeFormToObj();
      var reqObj = {};
      reqObj.kyc_transaction_id = this.presenter.models.account.kyc_transaction_id;
      reqObj.kyc_answers = [];

      for (var name in data) {
        var question_id = parseInt(name.substring(9));
        var answer_id = parseInt(data[name].substring(7));

        reqObj.kyc_answers.push({
          question_id: question_id,
          answer_id: answer_id
        });
      }

      this._submittedAnswers = reqObj;

      var formAnalyticsID = $('#questions-form').data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
      this._onSubmitAnswersCallback = this.presenter.addCallbackToAction('account.kyc_answers', $.proxy(this._onSubmitAnswers, this));
      this.presenter.performAction('account.kyc_answers', this._submittedAnswers);
    }

    return false;
  };

  this._setButtonLoadState = function (disabled) {
    if (disabled) {
      this._submitButton.mogo().setDisabledLoadState();
    } else {
      this._submitButton.mogo().removeDisabledLoadState();
    }
  };

  this._validatePageRequest = function () {
    var currentPath = window.location.pathname;

    // 1. check for verified email address
    if (!this.presenter.models.account.confirmed_at && !this.presenter.models.account.unconfirmed_email) {
      if (currentPath != this.paths.signup.verify) {
        this.history.goToUrl(this.paths.signup.verify);
      }
      return false;
    }
    if (this.presenter.hasAction('account.create_profile')) {
      // 2. check for completed profile info
      if (currentPath != this.paths.signup.create_profile) {
        this.history.goToUrl(this.paths.signup.create_profile);
      }
      return false;
    }
    if (!this.presenter.hasAction('account.create_kyc_questions') && !this.presenter.getModelProperty('account.valid_age') && !this.presenter.getModelProperty('account.valid_province')) {
      // 4. Check if the users province is not supported and they are under age
      this.history.goToUrl(this.paths.signup.declined.province_underage);
    } else if (!this.presenter.hasAction('account.create_kyc_questions') && !this.presenter.getModelProperty('account.valid_age')) {
      // 5. Check if the user is underage
      this.history.goToUrl(this.paths.signup.declined.underage);
    } else if (!this.presenter.hasAction('account.create_kyc_questions') && !this.presenter.getModelProperty('account.valid_province')) {
      // 6. Check if the users province is not supported
      this.history.goToUrl(this.paths.signup.declined.province);
    } else if (!this.presenter.hasAction('account.create_kyc_questions') && this.presenter.models.account.kyc_attempts >= 2 && this.presenter.models.account.kyc_decision != 'approved') {
      // kyc final
      if (currentPath != this.paths.signup.declined.kyc_last_attempt) {
        this.history.goToUrl(this.paths.signup.declined.kyc_last_attempt);
      }
    } else if (this.presenter.models.account.verification_level === 4) {
      // credit check denied
      if (currentPath != this.paths.signup.declined.kyc_denied) {
        this.history.goToUrl(this.paths.signup.declined.kyc_denied);
      }
    } else if (this.presenter.models.account.kyc_decision === 'declined' && this.presenter.models.account.kyc_attempts === 0 || this.presenter.models.account.kyc_decision === 'permanently_failed') {
      // kyc declined
      if (currentPath != this.paths.signup.declined.kyc_failed) {
        this.history.goToUrl(this.paths.signup.declined.kyc_failed);
      }
    } else if (this.presenter.models.account.kyc_decision === 'profile_not_found') {
      // kyc profile not found
      if (currentPath != this.paths.signup.declined.profile_not_found) {
        this.history.goToUrl(this.paths.signup.declined.profile_not_found);
      }
    } else if (this.presenter.hasAction('account.create_kyc_questions') || !this.presenter.models.account.credit_check_decision || this.presenter.models.account.credit_check_decision == 'timeout') {
      // kyc view
      if (currentPath == this.paths.signup.declined.province_underage || currentPath == this.paths.signup.declined.province || currentPath == this.paths.signup.declined.underage) {
        // double check if the person can create the kyc questions when on the declined page
        this.presenter.performAction('account.create_kyc_questions', { device_print: '' }, $.proxy(this.handleDeclinedState, this));
      } else if (this.presenter.models.account.existing_account_uuid) {
        // Just stay on the page (this.paths.signup.account_already_exists)
        // Credit check has matched an existing account to the same UUID
        // User is asked to login with pre-existing account (email address) instead
        // NOTE: backend has already deleted the new user account at this point.
        return false;
      } else if (currentPath != this.paths.signup.kyc_questions) {
        this.history.goToUrl(this.paths.signup.kyc_questions);
      }
    } else {
      return true;
    }
  };

  this.destroy = function () {
    if (this.questionsRequest) {
      this.questionsRequest.cancel(); // MA-554
    }
    this.presenter.removeCallbackFromAction('account.kyc_answers', this._onSubmitAnswersCallback);
    this.presenter.removeCallbackFromAction('account.create_kyc_questions', this._onReceiveQuestionsCallback);
  };
}